import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Container } from "@/components/shared/PageHeader";
import { fetchEvents } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { cn } from "@/lib/utils";

const Side = ({ ev, dir }) => {
  const next = dir === "next";
  if (!ev) return <div className="hidden sm:block" aria-hidden="true" />;
  return (
    <Link to={`/arrangement/${ev.id}`} className={cn("group flex min-w-0 items-center gap-4 py-6", next ? "justify-end text-right" : "justify-start")} data-testid={`event-nav-${dir}`}>
      {!next && <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-border transition-colors group-hover:bg-ink group-hover:text-paper"><ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" /></span>}
      <span className="min-w-0">
        <span className="t-mono block text-muted-foreground">{next ? "Neste i programmet" : "Førre i programmet"} · {fmtDate(ev.date, "d. MMM")}</span>
        <span className="mt-1 block truncate font-display text-[17px] font-semibold tracking-[-0.015em] u-hover sm:text-[19px]">{ev.title}</span>
      </span>
      {next && <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-border transition-colors group-hover:bg-ink group-hover:text-paper"><ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></span>}
    </Link>
  );
};

/** Leaf on through the programme: the event before and after this one, by date. */
export const EventPagination = ({ currentId }) => {
  const { data } = useQuery({ queryKey: ["events-all"], queryFn: () => fetchEvents({ limit: 100 }) });
  const list = data || [];
  const i = list.findIndex((e) => e.id === currentId);
  const prev = i > 0 ? list[i - 1] : null;
  const next = i >= 0 && i < list.length - 1 ? list[i + 1] : null;
  if (!prev && !next) return null;
  return (
    <nav className="border-t border-border" aria-label="Bla i programmet" data-testid="event-pagination">
      <Container className="grid gap-x-8 sm:grid-cols-2 sm:divide-x sm:divide-border">
        <Side ev={prev} dir="prev" />
        <div className="sm:pl-8"><Side ev={next} dir="next" /></div>
      </Container>
    </nav>
  );
};
